export default __webpack_public_path__ + "static/media/scene_01.819e5b4e.mp3";